﻿$.fn.dxCtrlBcListe = function custom_dxCtrlBcListe(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcliste dx-ctrl");
        this.createInstance(new cdxCtrlBcListe(this, option));
    }
    return this;
}

window.cdxCtrlBcListe = function (container, option) {
    var Me = this

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.appli == 'undefined') option.appli = null

    if (!option.readOnly) option.bddCtrl.mAddFunctionOnModifiedItemData(["bc_dossier", "bc_article", "bc_dossier_bc_appli", "bc_article_bc_appli"], container, function (action, itemData) { Me.mLoad() })

    var jauge = null
    function mConstruit() {
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + 'px' : ''))
        container.empty();

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")

        var $Div = $("<div style='text-align:center;'/>").appendTo(container)

        var firstLoad = true
        var opt = {
            dataSource: [],
            height: "100%",
            allowItemDeleting: false,
            noDataText: "",
            pageLoadMode: 'scrollBottom',
            indicateLoading: false,
            scrollingEnabled: false,
            itemTemplate(itemData, itemIndex, itemElement) {
                itemElement.css("color", "black")
                if (option.bddCtrl.getObjet(itemData).mGetTable().nom == "bc_article") {
                    //article
                    itemElement.css({
                        "padding": "10px",
                        "border-bottom": "1px solid rgb(81, 81, 89,0.2)",
                        //"display": "none"
                    })
                } else {
                    //Dossier
                    itemElement.css({
                        "padding": "10px"
                    })
                    itemElement = $("<div/>").appendTo(itemElement)
                    itemElement.css({
                        "padding": "10px",
                        "border": "1px solid rgb(81, 81, 89,0.2)",
                        "border-radius": "10px"
                    })
                }
                itemElement.addClass("state-hover")
                var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:65px;padding-right:10px;' rowspan='4'>").appendTo($Tr)
                var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo($Td).dxCtrlImageData({
                    bddCtrl: option.bddCtrl,
                    size: ((option.bddCtrl.getObjet(itemData).mGetTable().nom == "bc_article") ? 60 : 50),
                    data: itemData,
                    showTextOnImage: false,
                    showText: false,
                    fontSizeText: "30px",
                    allowClick: false,
                    noDataText: "(aucune image)"
                }).dxCtrlImageData("instance");
                var $Td = $("<td style='width:100%;vertical-align:top;height:15px;'/>").appendTo($Tr)
                var $DivTitle = $("<div style='overflow:hidden;text-overflow:ellipsis;font-variant:small-caps;letter-spacing:-0.5px;font-size:120%;'>" + ((itemData.objet == null) ? "" : itemData.objet).replace(/%%nom_appli%%/g, gestCognoss.mGetAppliCourante().nom) + "</div>").appendTo($Td)
                $DivTitle.attr("title", ((itemData.objet == null) ? "" : itemData.objet).replace(/%%nom_appli%%/g, gestCognoss.mGetAppliCourante().nom))
                //var $Td = $("<td style='width:1px;vertical-align:top;white-space:nowrap;font-size:70%;text-align:right;'/>").appendTo($Tr)
                if (option.bddCtrl.getObjet(itemData).mGetTable().nom == 'bc_dossier') {
                    $DivTitle.css("font-weight", "bold")
                    $DivTitle.css("font-size", "150%")
                    //$Td.css("width", "130px")
                }
                //var $TdPen = $("<td style='width:0px;vertical-align:top;' rowspan='2'/>").appendTo($Tr)
                //var $TdDel = $("<td style='width:px;vertical-align:top;' rowspan='2'/>").appendTo($Tr)
                //if (!option.readOnly && (option.appli == null || typeof option.appli.bcAppli == 'undefined' || option.appli.bcAppli.id_bc_appli == "0")) {
                //    $TdPen.css("width", "36px")
                //    $TdDel.css("width", "36px")
                //    $("<div/>").appendTo($TdPen).dxCtrlButton({
                //        icon: "fas fa-pen",
                //        txtTooltip: "Modifer",
                //        onClick: function (e) {
                //            e.event.stopPropagation()
                //            option.bddCtrl.getObjet(itemData).mShowPopup()
                //        }
                //    })
                //    $("<div/>").appendTo($TdDel).dxCtrlButton({
                //        icon: "fas fa-trash-alt",
                //        txtTooltip: "Poubelle",
                //        onClick: function (e) {
                //            e.event.stopPropagation()
                //            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                //                target: e.component.element(),
                //                contentTemplate: function (contentElement) {
                //                    contentElement.css("padding", "24px");
                //                    if (option.bddCtrl.getObjet(itemData).mGetTable().nom == 'bc_dossier') {
                //                        $("<div>Mettre le dossier<br/>et tous ses articles et ses dossiers<br/>à la corbeille.</div>").appendTo(contentElement)
                //                    } else {
                //                        $("<div>Mettre l'article à la corbeille.</div>").appendTo(contentElement)
                //                    }
                //                    $("<div style='padding-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                //                        text: "Confirmer",
                //                        width: "100%",
                //                        onClick: function (e) {
                //                            itemElement.slideUp(200)
                //                            option.bddCtrl.getObjet(itemData).mDelData(function () {
                //                                Me.mLoad()
                //                            })
                //                            tt.hide()
                //                        }
                //                    }).dxCtrlButton("instance")
                //                }
                //            }).dxCtrlTooltip("instance");
                //            tt.show()
                //        }
                //    })
                //}

                if (option.bddCtrl.getObjet(itemData).mGetTable().nom == 'bc_dossier') {
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%;vertical-align:top;height:15px;font-size:60%;' colspan='2'/>").appendTo($Tr)
                    var txt = ""
                    var nbDossier = option.bddCtrl.getObjet(itemData).objetMetier.mGetNbDossier()
                    var nbArticle = option.bddCtrl.getObjet(itemData).objetMetier.mGetNbArticle()
                    if (nbDossier > 0) { txt += "<b>" + nbDossier + "</b><span style='opacity:0.5;'> dossier" + ((nbDossier > 1) ? "s" : "") + "</span>" }
                    if (nbArticle > 0) { txt += ((txt.length > 0) ? "<span style='opacity:0.2;'> &bull; </span>" : "") + "<b>" + nbArticle + "</b><span style='opacity:0.5;'> article" + ((nbArticle > 1) ? "s" : "") + "</span>" }
                    $Td.html(txt)
                }
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;vertical-align:top;' colspan='2'/>").appendTo($Tr)
                var txt = ""
                if (typeof itemData.body_txt != 'undefined' && itemData.body_txt != null) {
                    txt = itemData.body_txt
                    txt = txt.replace(/%%nom_appli%%/g, gestCognoss.mGetAppliCourante().nom);
                    txt = txt.replace(/%%site_vitrine_appli%%/g, gestCognoss.mGetAppliCourante().urlvitrine);
                    txt = txt.replace(/%%site_app_appli%%/g, gestCognoss.mGetAppliCourante().urlapp);
                    txt = txt.replace(/\s{2,}/g, ' ').trim();
                    if (txt.length > 330) txt = txt.substring(0, 330) + "..."
                }
                $("<div style='white-space:normal;font-size:80%;'><i>" + txt + "</i></div>").appendTo($Td)

                var $Tr = $("<tr/>").appendTo($Table)
                if (gestCognoss.afficheSelectAppli()) {
                    //on affiche la liste des appli de l'élément
                    var $Td = $("<td style='width:100%;vertical-align:top;font-size:60%;' colspan='2'/>").appendTo($Tr)
                    var lstAppli = option.bddCtrl.getObjet(itemData).objetMetier.mGetLstAppli()
                    var txtLstAppli = ""
                    if (lstAppli.length == 0) { txtLstAppli = "(aucune application)" }
                    else {
                        lstAppli.forEach(function (o) { txtLstAppli += ((txtLstAppli.length > 0) ? ", " : "") + o.nom })
                    }
                    $Td.text(txtLstAppli)
                    //if (typeof option.appli.bcAppli != 'undefined') {
                    var urlLink = option.bddCtrl.getObjet(itemData).objetMetier.mGetLink(option.appli)
                    var $A = $("<a href='javascript:void(0)' class='state-hover' style='font-size:80%;'>" + urlLink + "</a>").appendTo(itemElement)
                    $A.on("click", function (e) {
                        e.stopPropagation()
                        var $temp = $("<input>");
                        $("body").append($temp);
                        $temp.val(urlLink).select();
                        document.execCommand("copy");
                        $temp.remove();
                        mNotify("L'adresse de la page a été copiée dans le presse-papier", "success", 6000)
                    })
                    //}
                } else {
                    var $Td = $("<td style='width:36px;vertical-align:top;font-size:60%;opacity:0.5;' colspan='2'/>").appendTo($Tr)
                    if (option.bddCtrl.getObjet(itemData).mGetTable().nom == "bc_article") {
                        //on affiche l'utilisateur
                        var $Table = $("<table/>").appendTo($Td)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='min-width:30px'/>").appendTo($Tr)
                        $("<div style='width:100%;height:30px;border-radius:50%;'/>").appendTo($Td).dxCtrlImgStrConUti({
                            bddCtrl: option.bddCtrl,
                            idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
                            id: itemData.id_utilisateur,
                            text: option.bddCtrl.getObjet("utilisateur", itemData.id_utilisateur).mGetLib1(),
                            hideText: true
                        })
                        var $Td = $("<td style='width:36px'>Ecrit par " + option.bddCtrl.getObjet("utilisateur", itemData.id_utilisateur).mGetLib1() + "<br/>Mise à jour il y a plus d'une semaine</td>").appendTo($Tr)
                    } else {
                        //on affiche le lien de l'élément
                        option.bddCtrl.getObjet(itemData).objetMetier.mGetElementLink().appendTo($Td)
                    }

                }
                //if (option.onSelect) itemElement.on("click", function (e) {
                //    e.stopPropagation()
                //    option.onSelect(itemData)
                //})
                ////if (option.onSelect) {
                ////    itemElement.on("click", function (e) {
                ////        option.onSelect(itemData)
                ////    })
                ////}
            },
            onItemClick: function (e) {
                if (option.onSelect) {
                    var itemData = e.itemData
                    if (typeof itemData == "undefined") {
                        const ds = e.component.option("lstTot");
                        itemData = ds[e.itemIndex]
                    }
                    option.onSelect(itemData)
                }
            },
            onContentReady: function (e) {
                e.element.find(".dx-list-reorder-handle").css("color", "gray")
                e.element.find(".dx-empty-message").css("color", "gray")
            }
        }
        if ((option.appli == null || typeof option.appli.bcAppli == 'undefined' || option.appli.bcAppli.id_bc_appli == "0")
            && !(option.txtSearch != null && option.txtSearch.length > 0)) {
            opt.onItemReordered = function (e) {
                var itemData = e.itemData
                if (typeof itemData == 'undefined') {
                    const ds = e.component.getDataSource().items();
                    itemData = ds[e.itemIndex]
                }
                var lstItemDossier = e.component.option("items").filter(function (item, idx) { return option.bddCtrl.getObjet(item).mGetTable().nom == "bc_dossier" })
                //var lstItemArticle = e.component.option("items").filter(function (item, idx) { return option.bddCtrl.getObjet(item).mGetTable().nom == "bc_article" })
                //e.component.reload();
                if (option.bddCtrl.getObjet(itemData).mGetTable().nom == "bc_dossier") {
                    if (e.toIndex > lstItemDossier.length - 1) {
                        mNotify("Impossible de placer un dossier parmi les articles.", "error", 3000)
                        e.component.reload();
                    } else {
                        var lst = []
                        //if (option.appli == null || typeof option.appli.bcAppli == 'undefined' || option.appli.bcAppli.id_bc_appli == "0") {
                        //    e.component.option("items").forEach(function (item, idx) {
                        //        if (option.bddCtrl.getObjet(item).mGetTable().nom == "bc_dossier") {
                        //            item.tri = idx
                        //            lst.push({
                        //                id_bc_dossier: item.id_bc_dossier,
                        //                tri: idx
                        //            })
                        //        }
                        //    })
                        //} else {
                        //    e.component.option("items").forEach(function (item, idx) {
                        //        if (option.bddCtrl.getObjet(item).mGetTable().nom == "bc_dossier") {
                        //            //var itemBcAppli = option.bddCtrl.mGetArray("bc_dossier_bc_appli").filter(function (itemBcApp) {
                        //            //    return itemBcApp.id_bc_appli == option.appli.bcAppli.id_bc_appli && item.id_bc_dossier == itemBcApp.id_bc_dossier
                        //            //})[0]
                        //            item.tri = idx
                        //            lst.push({
                        //                id_bc_dossier_bc_appli: item.id_bc_dossier_bc_appli,
                        //                tri: idx
                        //            })
                        //        }
                        //    })
                        //}

                        e.component.option("items").forEach(function (item, idx) {
                            if (option.bddCtrl.getObjet(item).mGetTable().nom == "bc_dossier") {
                                //var itemBcAppli = option.bddCtrl.mGetArray("bc_dossier_bc_appli").filter(function (itemBcApp) {
                                //    return itemBcApp.id_bc_appli == option.appli.bcAppli.id_bc_appli && item.id_bc_dossier == itemBcApp.id_bc_dossier
                                //})[0]
                                item.tri = idx
                                lst.push({
                                    id_bc_dossier: item.id_bc_dossier,
                                    tri: idx
                                })
                            }
                        })
                        option.bddCtrl.mAjaxCall({
                            command: "reorderdossierbc",
                            lst: lst
                        }, function () {
                        })
                    }
                } else {
                    if (e.toIndex < lstItemDossier.length) {
                        mNotify("Impossible de placer un article parmi les dossiers.", "error", 3000)
                        e.component.reload();
                    } else {
                        var lst = []
                        //if (option.appli == null || typeof option.appli.bcAppli == 'undefined' || option.appli.bcAppli.id_bc_appli == "0") {
                        //    e.component.option("items").forEach(function (item, idx) {
                        //        if (option.bddCtrl.getObjet(item).mGetTable().nom == "bc_article") {
                        //            item.tri = idx
                        //            lst.push({
                        //                id_bc_dossier: item.id_bc_article,
                        //                tri: idx
                        //            })
                        //        }
                        //    })
                        //} else {
                        //    e.component.option("items").forEach(function (item, idx) {
                        //        if (option.bddCtrl.getObjet(item).mGetTable().nom == "bc_article") {
                        //            //var itemBcAppli = option.bddCtrl.mGetArray("bc_article_bc_appli").filter(function (itemBcApp) {
                        //            //    return itemBcApp.id_bc_appli == option.appli.bcAppli.id_bc_appli && item.id_bc_article == itemBcApp.id_bc_article
                        //            //})[0]
                        //            item.tri = idx
                        //            lst.push({
                        //                id_bc_article: item.id_bc_article,
                        //                tri: idx
                        //            })
                        //        }
                        //    })
                        //}
                        e.component.option("items").forEach(function (item, idx) {
                            if (option.bddCtrl.getObjet(item).mGetTable().nom == "bc_article") {
                                //var itemBcAppli = option.bddCtrl.mGetArray("bc_article_bc_appli").filter(function (itemBcApp) {
                                //    return itemBcApp.id_bc_appli == option.appli.bcAppli.id_bc_appli && item.id_bc_article == itemBcApp.id_bc_article
                                //})[0]
                                item.tri = idx
                                lst.push({
                                    id_bc_article: item.id_bc_article,
                                    tri: idx
                                })
                            }
                        })
                        option.bddCtrl.mAjaxCall({
                            command: "reorderarticlebc",
                            lst: lst
                        }, function () {
                        })
                    }
                }
            }
            opt.itemDragging = {
                allowReordering: true
            }
        } else {
            opt.itemDragging = {
                allowReordering: false
            }
        }

        dx = $("<div style='display:inline-block;max-width:600px;width:100%;text-align:left;'/>").appendTo($Div).dxList(opt).dxList('instance');

        Me.mLoad()
    }

    this.mLoad = function () {
        if (option.txtSearch != null && option.txtSearch.length > 0) {
            jauge.mShow()
            if (option.appli == null || typeof option.appli.bcAppli == 'undefined' || option.appli.bcAppli.id_bc_appli == "0") {
                sql = "select tabbase.*,null as pathnom " +
                    "from (select " + option.bddCtrl.table.mGetIdTable("bc_article") + " as id_table,bc_article.id_bc_article as id,bc_article.dmo " +
                    "from bc_article where id_historique_sup is null) as tabbase "
            } else {
                sql = "select tabbase.*,null as pathnom " +
                    "from (select " + option.bddCtrl.table.mGetIdTable("bc_article") + " as id_table,bc_article.id_bc_article as id,bc_article.dmo " +
                    "from bc_article " +
                    "inner join (select id_bc_article from bc_article_bc_appli " +
                    "where id_bc_appli in (" + option.appli.bcAppli.id_bc_appli + ")) as lstart " +
                    "ON bc_article.id_bc_article=lstart.id_bc_article where id_historique_sup is null) as tabbase "
            }
            option.bddCtrl.mAjaxCall({
                command: "getdatavirtualgridawsm",
                nom_base: parametre.code_appli + "_aagest",
                dataSource: {
                    sql: sql,
                    textSearch: option.txtSearch,
                    triPertinence: "1"
                }
            }, function (data) {
                if (typeof data.ligne == 'undefined') data.ligne = []
                var lstArticle = option.bddCtrl.mGetArray("bc_article").filter(function (art) {
                    return data.ligne.filter(function (lig) { return art.id_bc_article == lig.id }).length > 0
                })
                //for (var i = 0; i < 5; i++) {
                //    lstArticle = lstArticle.concat(JSON.parse(JSON.stringify(lstArticle)))
                //}
                dx.option({
                    lstTot: lstArticle,
                    "dataSource": lstArticle,
                    noDataText: "Aucun article pour votre recherche"
                })
                jauge.mHide()
                container.css("height", "")
            })
        } else {
            var lstDossier = option.bddCtrl.mGetArray("bc_dossier").filter(function (o) {
                return o.id_bc_dossier_parent == ((option.elementBc) ? option.elementBc.id_bc_dossier : null) &&
                    ((option.appli != null && typeof option.appli.bcAppli != 'undefined' && option.appli.bcAppli.id_bc_appli != 0) ?
                        option.bddCtrl.mGetArray("bc_dossier_bc_appli").filter(function (o2) {
                            return o2.id_bc_appli == option.appli.bcAppli.id_bc_appli && o2.id_bc_dossier == o.id_bc_dossier
                        }).length > 0 :
                        true)
            }).sort(function (o1, o2) {
                return parseInt(o1.tri) - parseInt(o2.tri)
                //var tri1 = o1.tri
                //if (option.appli != null && typeof option.appli.bcAppli != 'undefined' && option.appli.bcAppli.id_bc_appli != 0) {
                //    var dataApp = option.bddCtrl.mGetArray("bc_dossier_bc_appli").filter(function (oo) {
                //        return oo.id_bc_appli == option.appli.bcAppli.id_bc_appli && oo.id_bc_dossier == o1.id_bc_dossier
                //    })[0]
                //    o1.id_bc_dossier_bc_appli = dataApp.id_bc_dossier_bc_appli
                //    tri1 = dataApp.tri
                //}
                //var tri2 = o2.tri
                //if (option.appli != null && typeof option.appli.bcAppli != 'undefined' && option.appli.bcAppli.id_bc_appli != 0) {
                //    var dataApp = option.bddCtrl.mGetArray("bc_dossier_bc_appli").filter(function (oo) {
                //        return oo.id_bc_appli == option.appli.bcAppli.id_bc_appli && oo.id_bc_dossier == o1.id_bc_dossier
                //    })[0]
                //    o2.id_bc_dossier_bc_appli = dataApp.id_bc_dossier_bc_appli
                //    tri2 = dataApp.tri
                //}
                //return parseInt(tri1) - parseInt(tri2)
            })
            var lstArticle = option.bddCtrl.mGetArray("bc_article").filter(function (o) {
                return o.id_bc_dossier_parent == ((option.elementBc) ? option.elementBc.id_bc_dossier : null) &&
                    ((option.appli != null && typeof option.appli.bcAppli != 'undefined' && option.appli.bcAppli.id_bc_appli != 0) ?
                        option.bddCtrl.mGetArray("bc_article_bc_appli").filter(function (o2) {
                            return o2.id_bc_appli == option.appli.bcAppli.id_bc_appli && o2.id_bc_article == o.id_bc_article
                        }).length > 0 :
                        true)
            }).sort(function (o1, o2) {
                return parseInt(o1.tri) - parseInt(o2.tri)
                //var tri1 = o1.tri
                //if (option.appli != null && typeof option.appli.bcAppli != 'undefined' && option.appli.bcAppli.id_bc_appli != 0) {
                //    var dataApp = option.bddCtrl.mGetArray("bc_article_bc_appli").filter(function (oo) {
                //        return oo.id_bc_appli == option.appli.bcAppli.id_bc_appli && oo.id_bc_article == o1.id_bc_article
                //    })[0]
                //    o1.id_bc_article_bc_appli = dataApp.id_bc_article_bc_appli
                //    tri1 = dataApp.tri
                //}
                //var tri2 = o2.tri
                //if (option.appli != null && typeof option.appli.bcAppli != 'undefined' && option.appli.bcAppli.id_bc_appli != 0) {
                //    var dataApp = option.bddCtrl.mGetArray("bc_article_bc_appli").filter(function (oo) {
                //        return oo.id_bc_appli == option.appli.bcAppli.id_bc_appli && oo.id_bc_article == o1.id_bc_article
                //    })[0].tri
                //    o2.id_bc_article_bc_appli = dataApp.id_bc_article_bc_appli
                //    tri2 = dataApp.tri
                //}
                //return parseInt(tri1) - parseInt(tri2)
            })
            var lstTot = lstDossier.concat(lstArticle)
            var opt = {
                lstTot: lstTot,
                "dataSource": lstTot,
                noDataText: "Ce dossier est vide"
            }
            dx.option(opt)
            container.css("height", "")
        }
    }

    this.export = function () {
        var lstArticle = option.bddCtrl.mGetArray("bc_article").filter(function (o) {
            return true
        }).sort(function (o1, o2) {
            return parseInt(o1.tri) - parseInt(o2.tri)
        })
        debugger;
        var lstId = ""
        lstArticle.forEach(function (article) {
            lstId += ((lstId.length > 0) ? "," : "") + article.id_bc_article
        })
        option.bddCtrl.mAjaxCall({ command: "exportbcarticle", lstId: lstId }, function (data) {
            mDownLoadFile(option.bddCtrl, data.urlziphtml)
            mDownLoadFile(option.bddCtrl, data.urlziptxt)
        })
    }

    this.element = function () { return container; }

    mConstruit();
}